"use strict";

// Import custom JS modules
import applyBreakpointChangeEvent from "./modules/_breakpoint-change.js";
import applyClientDetectionSelectors from "./modules/_client-detection.js";
import exposeHelperToWindow from "./helper/index.js";

// import loadSvgSymbols from "./modules/_load-svg-symbols.js"; // uncomment to load svg sprite
// import applyAnchorScroll from "./modules/_anchor-scroll.js"; // uncomment to initialize anchor scroll

exposeHelperToWindow();
applyClientDetectionSelectors();
applyBreakpointChangeEvent();

// loadSvgSymbols(); // uncomment to load svg sprite
// applyAnchorScroll(); // uncomment to initialize anchor scroll

// Import custom JS modules
import "./modules/_init-loops.js";
import "./modules/_header-scroll.js";
